<template>
		<div class="menuContentBox" v-if="getData">
			<div class="correntItem" :class="{active:btnStart==1}" @mouseover="btnStart=1">
				<div class="ditto"></div>
				<div class="after">
					<h4>{{getData[0].name}}</h4>
					<h1>{{getData[0].value}}<span style="font-size:16px">家</span></h1>
					<p>营业收入规模：</p>
					<p> 0万元（含） -100万元</p>
				</div>
			</div>
			<div class="correntItem" :class="{active:btnStart==2}" @mouseover="btnStart=2">
				<div class="ditto ditto1"></div>
				<div class="after">
					<h4>{{getData[1].name}}</h4>
					<h1>{{getData[1].value}}<span style="font-size:16px">家</span></h1>
				<p>营业收入规模：</p>
				<p> 100万元（含） -500万元</p>
				</div>
			</div>
			<div class="correntItem" :class="{active:btnStart==3}" @mouseover="btnStart=3">
				<div class="ditto ditto2"></div>
				<div class="after">
					<h4>{{getData[2].name}}</h4>
					<h1>{{getData[2].value}}<span style="font-size:16px">家</span></h1>
				<p>营业收入规模：</p>
				<p> 500万元（含） -2000万元</p>
				</div>
			</div>
			<div class="correntItem" :class="{active:btnStart==4}" @mouseover="btnStart=4">
				<div class="ditto ditto3"></div>
				<div class="after">
					<h4>{{getData[3].name}}</h4>
					<h1>{{getData[3].value}}<span style="font-size:16px">家</span></h1>
				<p>营业收入规模：</p>
				<p> 2000万元（含）以上</p>
				</div>
			</div>
		</div>
</template>

<script>
import {companyPointsSystem} from "@/api/integral";
export default {
	name: "index",
	components: {
		// DictRender
		
	},
	data() {
		return {
			btnStart:1,
			correntShow:0,
			getData: null,
		}
	},
	mounted() {
		this.getBannerList()
	},
	methods: {
		getBannerList() {
			this.getAction({
				url: companyPointsSystem.getCompanyData,
			}).then(res => {
				this.getData = res
			})
		},
	}
}
</script>

<style scoped lang="less">
.menuContentBox{
	position: relative;
	height:300px!important;
	width:1400px!important;
	display: flex;
	margin:30px auto!important;
	box-shadow: 1px 1px 5px 1px #defaff;
}
.correntItem{
	position: relative;
	height:300px;
	flex:1;
	cursor: pointer;
	transition: flex .7s,-webkit-box-flex .7s,-ms-flex .7s;
	.ditto{
		position: absolute;
		left:0;
		top:0;
		background: url(../../../../assets/img/jf/zz.jpg);
		background-size: cover;
		width:100%;
		height:100%;
		z-index: 9;
	}
	.ditto1{
		
		background: url(../../../../assets/img/jf/cc.jpg);
		background-size: cover;
	}
	.ditto2{
		
		background: url(../../../../assets/img/jf/cz.jpg);
		background-size: cover;
	}
	.ditto3{
		
		background: url(../../../../assets/img/jf/cs.jpg);
		background-size: cover;
	}

	.after{
		transition: flex .7s,-webkit-box-flex .7s,-ms-flex .7s;
		padding-left: 20px;
		padding-top: 50px;
		position: absolute;
		background-color: rgba(1, 35, 75, 0.6);
		left:0;
		top:0;
		width:100%;
		height:100%;
		z-index: 9;
	}
	h4,h1,p{
	color:#fff!important;
	}
	h1{
		font-size: 50px;
		margin-bottom: 40px;
		font-weight: 600!important;
	}
	p{
		line-height: 25px;
	}
}
.active{
	flex:1.5;
	.after{
		background-color: rgba(44, 141, 252, 0);
	}
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
	border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
	font-weight: 600;
}

:deep(.ant-btn) {
	border-radius: 0;
}
</style>